<template>
	<div class="texing">
		<div class="lh-culture-bg img" style="background-image:url(img/a7.jpg);"></div>
    	<div class="logo img"><img src="img/uniqueness/logo.png" /></div>
    	<div class="lh-texing-cont clearfix">
    		<div class="left lh-texing-l">
    			<div class="bg" style="background-image:url(img/uniqueness/a1.png);"></div>
    			<div class="btn">
    				<div data-music="img/audio/_07_01.mp3" data-page="8" data-idx="1" data-text="宜宾地处北纬29°16′，这里冬无严寒、夏无酷暑、霜雪稀少、雨水充沛，年平均温度在17.9℃左右。被联合国教科文组织与世界粮农组织定义为：
“地球同纬度上最适合酿造优质纯正蒸馏白酒的地区”。" @click="playMusic($event)" class="btn1" :class="btn[0]"><router-link to="/tianshi" replace><span><img src="img/uniqueness/dj.png" /></span></router-link></div>
    				<div data-music="img/audio/_08_01.mp3" data-page="9" data-idx="2" data-text="宜宾土壤有黄壤土、紫色土、水稻土、黄色石灰土及黄棕壤、新积土等六大类。其中占22.5%的黄壤土，呈弱酸性，粘性强，含沙量少、细腻，水分不易流失，为粮食种植与窖池制作提供了优越基础。宜宾地区三江汇流，充沛的水源保证了多种粮食作物充足的产量。另外，流经宜宾的岷江，水质优良，甘美可口、杂质少，可谓酿酒的上佳水源。" @click="playMusic($event)" class="btn2" :class="btn[1]"><router-link to="/dili" replace><span><img src="img/uniqueness/dj.png" /></span></router-link></div>
    				<div data-music="img/audio/_09_01.mp3" data-page="10" data-idx="3" data-text="古窖池群从明初一直连续使用至今，使用功能完好，是我国现存最早的、唯一仍在使用的地穴式曲酒发酵窖池。正所谓 “千年老窖万年糟，酒好须得窖池老”，在中国白酒企业中，五粮液拥有的古窖池数量最多、规模最大、历史最悠久，是保证五粮液质量的根本所在。" @click="playMusic($event)" class="btn3" :class="btn[2]"><router-link to="/guyao"><span><img src="img/uniqueness/dj.png" /></span></router-link></div>
    				<div data-music="img/audio/_10_01.mp3" data-page="11" data-idx="4" data-text="千百年来，五粮液始终坚持独特的纯粮固态酿造技艺。总结来说就是，1极3优6首创6精酿。所谓1极是工艺极端的复杂性。3优是指环境优势、老窖优势、匠人匠心优势。6首创则指五粮配方、包包曲、跑窖循环、沸点量水、双轮底发酵、勾兑双绝。而6精酿则是分层入窖、分层起糟、分层蒸馏、量质摘酒、按质并坛、分级储存。2008年，五粮液传统酿造技艺被列入国家级非物质文化遗产。" @click="playMusic($event)" class="btn4" :class="btn[3]"><router-link to="/renhe" replace><span><img src="img/uniqueness/dj.png" /></span></router-link></div>
    			</div>
    		</div>
    		<div class="right lh-texing-r">
    			<div class="lh-texing-img"><div class="icon"><img src="img/uniqueness/a2.png" /></div></div>
    			<div class="lh-texing-a">
    				<router-view></router-view>
    			</div>
    		</div>
    	</div>
    	<Footer :footerData="footerData"></Footer>
	</div>
</template>
<script type="text/javascript">
	import Footer from '@/components/Footer'
	//import {mapState} from 'vuex'
	export default{
		data(){
			return {
				footerData:{audioData:{total:'00:00',current:'00:00',percentage:0,icon:'icon-bofang',text:''},page:8,type:'culture'},
				on:'',
				btn:['on','','','']
			}
		},
		components:{
			Footer
		},
		computed:{
	      //...mapState(['username','count'])
	    },
	    mounted(e){
	    	if(this.$route.name !='uniqueness'){
	    		this.$router.push({ name: 'uniqueness'})
	    	}
	    },
	    created(e){
	    	var that=this;
	    },
		methods:{
			playMusic(e){
				var that=this,music = $(e.currentTarget).data('music'),page = $(e.currentTarget).data('page'),text = $(e.currentTarget).data('text'),idx = $(e.currentTarget).data('idx'),btns=['','','',''];
				if(idx.toString()){
					btns[idx]='on';
					that.btn=btns;
					if(idx=='4'){
						setTimeout(function(){
							btns=['','','',''];
							that.btn=btns;
						},1000)
					}
				}
				if(page){
					that.footerData.page=page;
				}
				if(text){
					that.footerData.audioData.text=text;
				}
				if(music){
					var audio = $('#audio')[0];
					audio.src=music;
					audio.play();
					that.on='on';
					//that.playSetFooterData({icon:"icon-zanting"});
					that.footerData.audioData.icon="icon-zanting";
					//输出总时间
					audio.addEventListener('loadedmetadata',function(e){
						console.log(audio.duration);
						var duration = s_to_hs(Math.floor(audio.duration));
						//that.playSetFooterData({total:duration});
						that.footerData.audioData.total=duration;
					});
					//输出当前播放时间
					audio.addEventListener('timeupdate',function(e){
						var currentTime = audio.currentTime;
						var currentTime1=audio.currentTime.toFixed(2);
						//var currentTime=(this.currentTime/60).toFixed(2).toString().replace(/\./g,":");
						var currentTime=s_to_hs(Math.floor(currentTime));
						that.footerData.audioData.current=currentTime;
						var duration = audio.duration;
						var percentage = 100 * currentTime1/duration;
						//that.playSetFooterData({percentage:percentage});
						that.footerData.audioData.percentage=percentage;
					});
					function s_to_hs(s){
					    //计算分钟
					    //算法：将秒数除以60，然后下舍入，既得到分钟数
					    var h;
					    h  =   Math.floor((s/60));
					    //计算秒
					    //算法：取得秒%60的余数，既得到秒数
					    s  =   s%60;
					    //将变量转换为字符串
					    h    +=    '';
					    s    +=    '';
					    //如果只有一位数，前面增加一个0
					    h  =   (h.length==1)?'0'+h:h;
					    s  =   (s.length==1)?'0'+s:s;
					    return h+':'+s;
					}
					//播放完成
					audio.addEventListener('ended',function(e){
						that.footerData.audioData.icon="icon-bofang";
						if(page==11){
							console.log(11111111)
							that.$router.push({ name: 'jiu'})
						}	
					});
				}
			},
		}
	}
</script>